import { Facebook, Instagram, LucideIcon, Youtube } from "lucide-react";

export interface SocialProfile {
  name: string;
  url: string;
  icon: LucideIcon;
}

/**
 * Goal Guru's own accounts, linked from the footer and the homepage showcase.
 * The Organization JSON-LD in public/index.html lists the same URLs under
 * `sameAs`; keep the two in step. (Lucide marks its brand icons deprecated,
 * to be dropped in v1; react-icons v5 needs TypeScript 5.1 for JSX.)
 */
export const SOCIAL_PROFILES: SocialProfile[] = [
  { name: "YouTube", url: "https://www.youtube.com/@goalguru_live", icon: Youtube },
  { name: "Instagram", url: "https://www.instagram.com/goalgurulive/", icon: Instagram },
  { name: "Facebook", url: "https://www.facebook.com/people/Goal-Guru-Smart-Football-Alerts/61590619695628/", icon: Facebook },
];
